import { render, staticRenderFns } from "./TheDelivery.vue?vue&type=template&id=1f58a7eb&"
import script from "./TheDelivery.vue?vue&type=script&lang=js&"
export * from "./TheDelivery.vue?vue&type=script&lang=js&"
import style0 from "./TheDelivery.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports